import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Reports } from './types'
import { RootState } from '../types'


export const state: Reports = {
  reports: [],
  currentReport: {},
  filterReports: [],
  responseMessage: '',
  responseError: false,
  graphView: false,
  ondemand: true,
  useMock: false
}

const namespaced: boolean = true

export const reports: Module<Reports, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}